exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customButtonClassBox{background:#fff;border:1px solid #8a8a8a;color:#8a8a8a;font-size:.9vw;border-radius:4px;padding:.37vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1);font-family:Poppins-Light}.customRedButtonClassBox{background:#fff;border:1px solid red;color:red;font-size:.9vw;border-radius:5px;padding:.4vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1)}", ""]);

// exports
